import { Subscription } from 'rxjs/Rx';
import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptionsArgs, Request, Response, ConnectionBackend, RequestOptions } from "@angular/http";
import { Observable } from 'rxjs/Observable';

import { AutenticacaoService } from './../../app-services/autenticacao.service';

@Injectable()
export class HttpClient extends Http {

  pendingRequests: number = 0;
  showLoading: boolean = false;

  constructor
    (
    protected _backend: ConnectionBackend,
    protected _defaultOptions: RequestOptions
    ) {
    super(_backend, _defaultOptions);
  }

  _setCustomHeaders(options?: RequestOptionsArgs): RequestOptionsArgs {
    if (!options) {
      options = new RequestOptions({});
    }
    if (!options.headers) {
      options.headers = new Headers();
    }
    if(!options.headers.has('Content-Type')){
      options.headers.append("Content-Type", "application/json");
    }else{
      if(options.headers.get('Content-Type') == "multipart/form-data"){
        options.headers.delete('Content-Type');
      }
    }
    options.headers.append("X-Key-Inflection", "camel");
    if (localStorage.getItem("usuarioAtual")) {
      let usuario = JSON.parse(localStorage.getItem("usuarioAtual"));
      if (!options.headers.has('Authorization')) {
         options.headers.append("Authorization", "Bearer " + usuario.token);
      }

    }
    return options;
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    options = this._setCustomHeaders(options);
    return super.request(url, options);
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    options = this._setCustomHeaders(options);
    return super.get(url, options);
  }

  post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    options = this._setCustomHeaders(options);
    return super.post(url, body, options);
  }

  put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    options = this._setCustomHeaders(options);
    return super.put(url, body, options);
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    options = this._setCustomHeaders(options);
    return super.delete(url, options);
  }

  patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    options = this._setCustomHeaders(options);
    return super.patch(url, body, options);
  }

  enviarMidia(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return super.post(url, body, options);
  }

}


// WEBPACK FOOTER //
// ./src/app/utils/http-client/HttpClient.ts